/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { getTokenFromCookies, getCookie } from '../hooks/useCookie';

const QUERIES = {
  GET_QA_FOR_BROADBAND: gql`
    query getQAForBroadband($uan: String!) {
      getQAForBroadband(uan: $uan) {
        accountNumber
        serviceDetails {
          activeServices
          phoneNumber
        }
      }
    }
  `,
  GET_QA_FOR_FIXEDLINE: gql`
    query getQAForFixedline($uan: String!, $fixedLineNumber: String!) {
      getQAForFixedline(uan: $uan, fixedLineNumber: $fixedLineNumber) {
        accountNumber
        serviceDetails {
          activeServices
        }
      }
    }
  `,
  GET_NLE: gql`
    query getNLE($nleId: Int!) {
      getNLE(nleId: $nleId) {
        activeFthPathsQuantity
        activePathsQuantity
        activePathsQuantityNo
        spareFthPathsQuantity
        spareFthPathsQuantityOnt
        spareFthPathsQuantityOntOn
        sparePathsQuantity
        sparePathsQuantityNo
        status
      }
    }
  `,
  GET_AREA_CODE: gql`
    query areaCodes {
      areaCodes {
        AREA_CODE
      }
    }
  `,
  SAVE_ASCERTAIN: gql`
    mutation saveAscertainDetails(
      $reference: String!
      $offerId: Int!
      $ascertainRequest: AscertainRequestInput!
      $cartType: CartType
    ) {
      saveAscertainDetails(
        reference: $reference
        offerId: $offerId
        ascertainRequest: $ascertainRequest
        cartType: $cartType
      ) {
        appointmentType
        hasActiveBroadband
        keepMobileNumber
        offerId
        phoneNumber
        prospectReference
        provisionBroadband
        provisionVobb
      }
    }
  `,
};

export const getQAForBroadband = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_QA_FOR_BROADBAND,
    variables,
  });
  return data;
};
export const getQAForFixedline = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_QA_FOR_FIXEDLINE,
    variables,
  });
  return data;
};
export const getAreaCode = async ({ graphql }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_AREA_CODE,
  });
  return data;
};
export const getNLE = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_NLE,
    variables,
  });
  return data;
};
export const saveAscertain = async ({ graphql, variables = {} }) => {
  let ascertainVariables = {};
  ascertainVariables = {
    ...variables,
    token: getTokenFromCookies(),
    cartType: variables.cartType ? variables.cartType : getCookie('cart_Type'),
  };
  if (!getCookie('cart_Type')) delete ascertainVariables.cartType;
  const { data } = await graphql.mutate({
    mutation: QUERIES.SAVE_ASCERTAIN,
    variables: ascertainVariables,
  });
  return data;
};
